var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 257 256",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logosVitejs0",
    x1: "-.828%",
    x2: "57.636%",
    y1: "7.652%",
    y2: "78.411%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#41D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BD34FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logosVitejs1",
    x1: "43.376%",
    x2: "50.316%",
    y1: "2.242%",
    y2: "89.03%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFEA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "8.333%",
    stopColor: "#FFDD35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFA800"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logosVitejs0)",
    d: "M255.153 37.938L134.897 252.976c-2.483 4.44-8.862 4.466-11.382.048L.875 37.958c-2.746-4.814 1.371-10.646 6.827-9.67l120.385 21.517a6.5 6.5 0 0 0 2.322-.004l117.867-21.483c5.438-.991 9.574 4.796 6.877 9.62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#logosVitejs1)",
    d: "M185.432.063L96.44 17.501a3.27 3.27 0 0 0-2.634 3.014l-5.474 92.456a3.268 3.268 0 0 0 3.997 3.378l24.777-5.718c2.318-.535 4.413 1.507 3.936 3.838l-7.361 36.047c-.495 2.426 1.782 4.5 4.151 3.78l15.304-4.649c2.372-.72 4.652 1.36 4.15 3.788l-11.698 56.621c-.732 3.542 3.979 5.473 5.943 2.437l1.313-2.028l72.516-144.72c1.215-2.423-.88-5.186-3.54-4.672l-25.505 4.922c-2.396.462-4.435-1.77-3.759-4.114l16.646-57.705c.677-2.35-1.37-4.583-3.769-4.113"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVite);
export default __webpack_public_path__ + "static/media/vite.f437ef804d3f34f7eb2084d2695565b3.svg";
export { ForwardRef as ReactComponent };